import { Link } from '@tanstack/react-router';

export function renderMentionLink({ userId, label }: { userId: string; label: string }) {
  return (
    <Link
      to="/profile/$userId"
      params={{ userId }}
      className="rounded bg-primary/10 text-primary px-1 hover:bg-primary/20 hover:underline"
      onClick={(e) => e.stopPropagation()}
    >
      @{label}
    </Link>
  );
}
